<template>
  <div class="resp_mid_nav_wrap">
    <div :class="`resp_mid_nav_outer${menuMobile ? ' active' : ''}`">
      <a
        href="#"
        @click.stop.prevent="onToggle()"
        :class="`responsive_nav resp_mid_nav${menuMobile ? ' active' : ''}`"
      >
        <span></span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'MenuMobileButton',
  computed: mapState(['menuMobile']),
  methods: {
    onToggle() {
      this.setMenuMobile(!this.menuMobile)
    },
    ...mapMutations(['setMenuMobile']),
  },
}
</script>

<style></style>
